// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeResourcesRedblue = {
  redblueActivity: "RedBlue アクティビティ",
  redblueActivityCamp: "RedBlue アクティビティ陣営",
  redblueActivityMember: "RedBlue アクティビティメンバー",
  redblueActivitySeat: "RedBlue アクティビティ席",
  redblueActivityTask: "RedBlue アクティビティタスク",
  redblueAuth: "RedBlue 認証",
  redblueDirectorActivityTasks: "RedBlue ディレクタータスク",
  redblueDirectorDispatchTarget: "RedBlue ディレクター配信対象",
  redblueDirectorEventSubject: "RedBlue ディレクターイベント主体",
  redblueDirectorNoticeTarget: "RedBlue ディレクター通知対象",
  redblueJudgeScoreRecord: "RedBlue 採点記録",
  redblueMember: "RedBlue メンバー",
  redblueParticipant: "RedBlue 参加者",
  redblueParticipantReport: "RedBlue 参加者レポート",
  redblueParticipantReportTemplate: "RedBlue 参加者レポートテンプレート",
  redblueScheme: "RedBlue スキーム",
  redblueSchemeVersion: "RedBlue スキームバージョン",
  redblueDirector: "RedBlue ディレクター",
  redblueDirectorActivityTask: "RedBlue ディレクターアクティビティタスク",
  redblueDirectorTaskAssignment: "RedBlue ディレクタータスク割り当て",
  redblueDirectorTaskCodes: "RedBlue ディレクタータスクコード",
  redblueEnvironment: "RedBlue 環境",
  redblueIntelligence: "RedBlue インテリジェンス",
  redblueJudge: "RedBlue ジャッジ",
  redblueJudgeFinalScore: "RedBlue 最終スコア",
  redblueObserver: "RedBlue オブザーバー",
  redblueParticipantActivityTask: "RedBlue 参加者アクティビティタスク",
  redblueSchemeDesign: "RedBlue スキーム設計",
  redblueSchemeTopologyBinding: "RedBlue スキームトポロジーバインディング",
  redblueSchemeTopologySync: "RedBlue スキームトポロジー同期",
  redblueBusinessEvent: "RedBlue 業務イベント",
} as const;
